<template>
  <div class="poz_rel overflow-hidden">
    <div
      class="wrapper_file_upload"
      :style="{ display: selectedFile ? 'none' : 'flex'}"
      :class="{ highlight: highlight }"
      @dragover.prevent
      @drop.stop.prevent="handleDrop"
      @dragenter.stop.prevent="onDragEnter"
      @dragleave.stop.prevent="onDragLeave"
    >
      <label class="file_upload">
        <input
          :disabled="hasUnresolvedDependencies"
          accept="image/*, application/pdf"
          id="uploaded-file"
          class="uploaded-file"
          type="file"
          name="file"
          ref="image"
          @change="onFilePicked"
        />
        <!-- <img class="upload_img" src="../../assets/images/svg/upload.svg" alt="upload" /> -->
        <div class="text1 color-black" v-html="$t(this.texts.receiptUpload1)"></div>
        <div class="text2 color-black" v-html="$t(this.texts.receiptUpload2)"></div>
      </label>
      <button
        href="#"
        class="btn btn_abs btn-light"
        @click.prevent="selectAnother"
      >{{ $t(this.texts.choose) }}</button>
    </div>

    <div v-show="!!selectedFile" class="receipt-widget">
      <receipt-scanner
        :key="attempts"
        v-model="receipt"
        class="receipt-scanner"
        :apiUrl="apiUrl"
        ref="receiptScanner"
        :file="selectedFile"
        @input="onInput($event)"
        @uploadError="handleUploadError"
        v-bind="$props"
        :show="!!selectedFile"
        :controlsBackground="colorSchema"
        :cropColor="colorSchema"
      >
        <template slot="crop">
          <span :title="$t(cropTitle)" v-b-tooltip>
            <svg width="24" height="24" viewBox="0 0 14 14" fill="#0057B8" xmlns="http://www.w3.org/2000/svg">
              <path d="M0.499086 4.23583C-0.166362 4.23583 -0.166362 3.21207 0.499086 3.21207H3.21207V0.499086C3.21207 -0.166362 4.23583 -0.166362 4.23583 0.499086V3.21207H10.2249C10.532 3.21207 10.7367 3.46801 10.7367 3.72395V9.71298H13.5009C14.1664 9.71298 14.1664 10.7367 13.5009 10.7367H10.7367V13.5009C10.7367 14.1664 9.71298 14.1664 9.71298 13.5009V10.7367H3.72395C3.46801 10.7367 3.21207 10.532 3.21207 10.2249V4.23583H0.499086ZM9.71298 9.71298V4.23583H4.23583V9.71298H9.71298Z" />
            </svg>
          </span>
        </template>
        <template slot="drag">
          <span :title="$t(dragTitle)" v-b-tooltip>
            <svg width="24" height="24" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="feather feather-move">
              <path d="M14 6.99998C14 6.99998 14 6.99998 14 6.9655C14 6.82757 13.931 6.70688 13.8448 6.62067L11.6897 4.46551C11.4655 4.25861 11.1379 4.27585 10.931 4.49999C10.7414 4.70688 10.7414 5.03447 10.931 5.24137L12.1724 6.48274H7.53448V1.82758L8.77586 3.06896C8.98276 3.29309 9.32759 3.29309 9.53448 3.10344C9.75862 2.89654 9.75862 2.55172 9.56897 2.34482C9.55172 2.32758 9.55172 2.32758 9.53448 2.31034L7.37931 0.155172C7.17241 -0.051724 6.82759 -0.051724 6.62069 0.155172L4.46552 2.31034C4.24138 2.51723 4.24138 2.84482 4.43103 3.06896C4.63793 3.29309 4.98276 3.29309 5.18966 3.10344C5.2069 3.0862 5.2069 3.0862 5.22414 3.06896L6.46552 1.82758V6.44826H1.82759L3.06897 5.20688C3.27586 4.98275 3.25862 4.65516 3.03448 4.44826C2.82759 4.25861 2.5 4.25861 2.2931 4.44826L0.155172 6.62067C-0.0517241 6.82757 -0.0517241 7.17239 0.155172 7.37929L2.31034 9.53446C2.53448 9.74135 2.86207 9.72411 3.06897 9.49997C3.25862 9.29308 3.25862 8.96549 3.06897 8.7586L1.82759 7.53446H6.44828V12.1724L5.2069 10.931C4.98276 10.7241 4.65517 10.7414 4.44828 10.9655C4.25862 11.1724 4.25862 11.5 4.44828 11.7069L6.60345 13.862L6.67241 13.8965C6.7069 13.931 6.74138 13.9482 6.77586 13.9655C6.84483 14 6.91379 14 6.98276 14C7.12069 14 7.24138 13.931 7.32759 13.8448L9.48276 11.6896C9.68966 11.4655 9.67241 11.1379 9.44828 10.931C9.24138 10.7414 8.91379 10.7414 8.7069 10.931L7.51724 12.1724V7.53446H12.1379L10.8966 8.77584C10.6724 8.98273 10.6724 9.32756 10.8621 9.53446C11.069 9.75859 11.4138 9.75859 11.6207 9.56894C11.6379 9.5517 11.6379 9.5517 11.6552 9.53446L13.8103 7.37929C13.8276 7.34481 13.8621 7.32757 13.8793 7.29308C13.8966 7.27584 13.9138 7.24136 13.931 7.20688C13.9828 7.13791 14 7.06895 14 6.99998Z" fill="#0057B8"/>
            </svg>
          </span>
        </template>
        <template slot="erase">
          <span :title="$t(eraseTitle)" v-b-tooltip>
            <svg width="25" height="25" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" class="feather feather-edit-2">
              <path fill-rule="evenodd" clip-rule="evenodd" d="M11.0205 1L1.96954 10.051L1.03782 13.6447L4.63159 12.713L13.6826 3.66205L11.0205 1Z" stroke="#0057B8" stroke-linejoin="round"/>
            </svg>
          </span>
        </template>
        <template slot="zoomIn">
          <span :title="$t(zoomInTitle)" v-b-tooltip>
            <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" class="feather feather-zoom-in">
              <path d="M1 7H13M7 1V13V1Z" stroke="#0057B8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
        </template>
        <template slot="zoomOut">
          <span :title="$t(zoomOutTitle)" v-b-tooltip>
            <svg width="14" height="4" viewBox="0 0 14 2" fill="none" xmlns="http://www.w3.org/2000/svg" class="feather feather-zoom-out">
              <path d="M1 1L13 1" stroke="#0057B8" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
        </template>
      </receipt-scanner>
      <button
        href="#"
        @click.prevent="selectAnother"
        class="btn btn-light"
        style="bottom:0"
      >{{ $t(this.texts.choose) }}</button>
    </div>
  </div>
</template>

<script>
import { ReceiptScanner } from "../receipt-editor";
import "@/assets/styles/receipt-editor.css";
import { mapActions } from 'vuex';

export default {
  name: "receipt-processor",
  components: {
    ReceiptScanner
  },
  data () {
    return {
      receipt: null,
      apiUrl: "https://receipt.justsnap.eu", // api that will be used to retrieve "image points"
      selectedFile: null,
      processedFile: null,
      uploadSectionHover: false,
      highlight: false,
      attempts: 0,
      selectedValidate: false,
      processedValidate: false
    };
  },
  props: {
    successAction: Object,
    backgroundColorBtn: {
      required: false,
      type: String,
      default: "#000"
    },
    borderColorBtn: {
      required: false,
      type: String,
      default: ""
    },
    textColorBtn: {
      required: false,
      type: String,
      default: "#fff"
    },
    textBtn: {
      required: false,
      type: String,
      default: "WEITER"
    },
    borderRadiusBtn: {
      required: false,
      type: String,
      default: ""
    },
    fieldId: String,
    requires: {
      type: Array
    },
    phrases: {
      type: Array
    },
    cornerDetectionPhrases: {
      type: Array
    },
    hideEraser: {
      type: Boolean
    },
    hideZoomer: {
      type: Boolean
    },
    skipCornerDetection: {
      type: Boolean
    },
    eraseColor: {
      type: String
    },
    eraseSize: {
      type: Number
    },
    cropColor: {
      type: String
    },
    cropBackground: {
      type: String
    },
    cropTitle: {
      type: String
    },
    eraseTitle: {
      type: String
    },
    dragTitle: {
      type: String
    },
    selectImageTitle: {
      type: String
    },
    selectAnotherTitle: {
      type: String
    },
    zoomInTitle: {
      type: String
    },
    zoomOutTitle: {
      type: String
    },
    controlsBackground: {
      type: String
    },
    postBillUrl: {
      type: String,
      default: "https://receipt.justsnap.eu/postBill"
    },
    colorSchema: {
      required: false,
      type: String,
      default: "#8B8B8B"
    },
    tokenName: {
      required: false,
      type: String,
      default: "token"
    },
    reUpload: {
      required: false,
      type: Boolean
    },
    texts: {
      required: false,
      type: Object,
      default: () => {}
    },
    selected: [Blob,File],
    internalButton: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  watch: {
    processedFile (value) {
      this.processedValidate = !!value;
    },
    selectedFile (value) {
      this.selectedValidate = !!value;
    },
    isImageCorrect (val) {
      this.$eventHub.$emit('canProceedNext', val)
    }
  },
  mounted () {
    this.selectedFile = this.$store.getters.receiptImage === '' ? null : (this.selected || null)
    this.$eventHub.$on("sendReceipt-event", this.send);
  },
  computed: {
    ...mapActions(['uploadError']),
    isImageCorrect () {
      return (this.processedValidate && this.selectedValidate);
    },
    hasUnresolvedDependencies () {
      return this.$store.getters.hasUnresolvedDependencies(this.requires);
    }
  },
  methods: {
    handleUploadError () {
      this.uploadError()
    },
    send () {
      //send receipt then ->
      this.$store.dispatch("setComponentStatus", {
        component: this.fieldId,
        status: false
      });
      const data = {
        image: this.receipt,
        apiUrl: this.postBillUrl,
        customerToken: this.$store.getters.customerToken,
        campaignId: "pg-template"
      }; // receipt info

      if (this.reUpload) {
        data["receiptToken"] = this.$route.query[this.tokenName];
        data["customerToken"] = 1;
        data["campaignId"] = "pg-template-re";
      }
      this.$store.dispatch("uploadReceipt", data).then(r => {
        if (this.internalButton) this.$refs.sendButton.loading = false;
        const fn = this.successAction.fn;
        const params = this.successAction.params;
        this[fn](params, this);
      })
        .catch(err => {
          if (this.internalButton) this.$refs.sendButton.loading = false;
        });
    },
    onFilePicked (event) {
      const files = event.target.files || event.dataTransfer.files;
      this.handleFiles(files);
    },
    handleDrop (e) {
      let dt = e.dataTransfer;
      let files = dt.files;
      this.handleFiles(files);
    },
    handleFiles (files) {
      const maxfilesize = 1024 * 1024 * 16; // 1 Mb

      if (files && files[0]) {
        let filename = files[0].name;

        if (filename && filename.lastIndexOf(".") <= 0) {
          return;
        }

        if (files[0].size > maxfilesize) {
          this.showModal(this.$t(this.texts.fileSizeLimit));
          return;
        }
        const extension = files[0].name.split(".").pop();
        const found = ["png", "jpg", "jpe", "jpeg", "tiff", "pdf"].filter(
          ext => ext === extension.toLowerCase()
        );
        if (!found.length) {
          this.showModal(this.$t(this.texts.wrongFormat));
          return;
        }
        this.attempts++;
        this.$nextTick().then(() => {
          this.selectedFile = files[0];
          this.processedFile = null;
        });
      }
    },
    onDragEnter () {
      this.highlight = true;
    },
    onDragLeave () {
      this.highlight = false;
    },
    onInput (data) {
      // this.$emit("component-updated", data);
      this.$store.dispatch("setComponentStatus", {
        component: this.fieldId,
        status: true
      });
      this.processedFile = data;
      this.$emit("component-updated", {
        selected: data
      });
    },
    selectAnother () {
      this.$refs.image.click();
    }
  },
  beforeDestroy () {
    this.$eventHub.$off("sendReceipt-event", this.send);
  }
};
</script>

<style scoped lang="scss">
.btn-light{
  margin-top: 20px;
  padding: 10px !important;
}
.fade-enter-active,
.fade-leave-active {
  opacity: 1;
  transition: 0.4s;
}
.uploadIcon {
  position: absolute;
  top: 0;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.file_upload input[type="file"] {
  display: none;
}
.hidden {
  display: none;
}
.receipt-uploader {
  overflow: hidden;
}

.receipt-scanner /deep/ {
  width: 100%;
  .layout > .container {
    border: 0;
    padding: 0;
  }
  .canvas-container {
    > div {
      display: flex;
      flex-direction: column;

      .controls {
        background: transparent;
        order: -1;

        .btn-group {
          display: flex;
          justify-content: space-around;
          width: 100%;

          @media (max-width: 767px) {
            width: 100%;
          }

          label {
            padding: 0;
            flex-grow: 1;
          }

          .btn {
            background: none;
            border: none;
            border-right: 1px solid;
            text-transform: uppercase;
            cursor: pointer;

            &:last-child {
              border: none;
            }

            span {
              // padding-top: 10px;
            }

            &:hover span,
            &.active span {
              color: white;

              &:after {
                content: "";
                position: absolute;
                width: 60%;
                border: 2px solid white;
                bottom: -10px;
                left: 0;
                right: 0;
                margin: auto;
              }
            }
          }
        }
      }

      .scanner-bar {
        background: #4f4f4f;
        box-shadow: 0 0 10px #4f4f4f;
      }

      .text {
        p {
          transform: translate(-50%, 0%);
        }
      }
    }
  }
}

.inputfile {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  overflow: hidden;
  position: absolute;
  z-index: -1;
}

.poz_rel {
  position: relative;
  min-height: 450px;
  padding: 24px;
  background-color: #FFFFFF;
  box-shadow: 0px 16px 32px -3px #EBEBFA;
  border-radius: 16px;

  @media (max-width: 450px) {
    padding: 0px;
  }
}
.receipt-widget {
  position: relative;
  height: 100%;
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  padding: 15px 5px;
  .btn_abs {
    z-index: 1000;
  }
}
.wrapper_file_upload {
  position: relative;
  height: 100%;
  background: #F5FAFF;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 54px;
  transition: background-color 300ms;
  background: #F5FAFF;
  border: 1px dashed #6676D1;
  box-sizing: border-box;
  border-radius: 8px;

  @media (max-width: 767px) {
    padding-left: 25px;
    padding-right: 25px;
  }
  &_prog {
    border-style: solid;
  }
  .file_upload {
    width: 100%;
    text-align: left;
    cursor: pointer;
    padding-top: 40px;
    padding-bottom: 20px;
    .text {
      &1 {
        font: normal normal bold 24px/30px 'Plus Jakarta Sans';
        letter-spacing: 0px;
        color: #080821;
        opacity: 1;
        padding-bottom: 15px;
      }

      &2 {
        font: normal normal normal 16px/25px 'Plus Jakarta Sans';
        letter-spacing: 0px;
        color: #1C1C73;
        opacity: 1;
      }
    //   line-height: 48px;
    //   @media (max-width: 767px) {
    //     line-height: 32px;
    //   }
    }
  }
}
.upload_img {
//   width: 44px;
  width: 10vh;
  margin-bottom: 30px;
}
.file_upload input[type="file"] {
  display: none;
}
.btn_abs {
  position: absolute;
  margin: 0 auto;
  bottom: 30px;
}
.btn {
  padding: 10px 30px;
  width: 50%;
  @media (max-width: 767px) {
    width: 70%;
    padding: 10px 30px;
  }
}
.highlight {
  background-color: #c4f3f3;
}
.overflow-hidden {
  overflow: hidden;
}
</style>
